import Modal from "../../../../../UI/Modal/Modal";
import {IModalAddLimit} from "./limits.interface";
import {handleCreateLimit} from "../../../utils/local.request.api";
import {Box, Checkbox, FormControlLabel, Grid, Radio, RadioGroup, Typography} from "@mui/material";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import {fnLocalizeFilter} from "../../../../../../services/localize.service";
import React, {useEffect, useMemo, useState} from "react";
import {ICardPurses} from "../../../../../../services/response.interface";
import {cardAPI} from "../../../../../../services/cardAPI.service";
import {useGlobalContext} from "../../../../../../services/context.service";
import InputCheckbox from "../../../../../UI/Input/InputCheckbox";
import InputFilled from "../../../../../UI/Input/InputFilled";
import {useAppDispatch} from "../../../../../../hooks/redux";

interface IAddLimit extends ICardPurses {
    checked?: boolean;
}

export default function ModalAddLimit({title, isShow = false, cardId, handleClose, accountSubType}: IModalAddLimit) {
    /* Получаем языковую локаль */
    const {locale} = useGlobalContext();
    const dispatch = useAppDispatch();

    /* Получаем все доступные кошельки карт */
    const {data: cardPurses = {purses: []}} = cardAPI.useFetchCardPursesQuery({locale});
    const {data: limitTypes = {types: []}} = cardAPI.useFetchCardLimitsTypesQuery({locale, accountSubType});

    /* Получаем список счетов выбранного клиента */
    const [getLimits] = cardAPI.useLazyFetchLimitsByCardQuery();

    const [purses, setPurses] = useState<IAddLimit[]>([]);
    const [selectedType, setSelectedType] = React.useState('');
    const [selectedLimit, setSelectedLimit] = React.useState('');
    const [limitAmount, setLimitAmount] = useState<number>(0);

    useEffect(() => {
        if (limitTypes.types.length > 0) {
            setSelectedType(limitTypes.types[0].remark);
            setSelectedLimit(limitTypes.types[0].items[0].remark);
            setPurses(cardPurses.purses);
        }
    }, [limitTypes])

    /* Нажатие на ОК при создании лимита */
    const handleBtnCreateLimit = () => {

        const newLimitIds = purses.filter(p => p.checked).map(p => ({purseId: p.purseId}));
        const findType = limitTypes.types.find(type => type.remark === selectedType);

        const findLimit = findType && findType.items.find(limit => limit.remark === selectedLimit);

        findLimit && handleCreateLimit({
            limitType: findLimit.id, limitAmount, attachedPurses: newLimitIds, locale, dispatch, cardId
        }).then(res => {

            if (res) {
                getLimits({locale, cardId});
                handleClose();
            }
        });


    };

    const handleSelectAll = (e: any) => {
        const {checked, id} = e.target;
        let newPurses = [...purses];

        newPurses = newPurses.map(p => {
            return (p.useBasePurse) ? {...p, checked: checked} : {...p}
        });


        setPurses([...newPurses]);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {id, checked} = e.target;
        const idx = purses && purses.findIndex(p => p.purseId === +id);

        let newPurses = [...purses];
        newPurses[idx] = {...newPurses[idx], checked}

        setPurses(newPurses);
    };

    const renderPursesCommon = useMemo(() => {
        return purses && purses.filter(purse => {
            if (accountSubType === 101) return purse.useBasePurse;
            if (accountSubType === 102) return !purse.useBasePurse;
        }).map(purse => (<InputCheckbox
            key={purse.purseId}
            onChange={handleChange}
            label={purse.remark}
            id={`${purse.purseId}`}
            defaultChecked={purse.checked}
        />));
    }, [purses, accountSubType]);

    const handleTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedType(event.target.value);
    };

    const handleLimitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedLimit(event.target.value);
    };

    const renderType = useMemo(() => {
        return <RadioGroup onChange={handleTypeChange}>
            {limitTypes.types.map((type, idx) => (
                <FormControlLabel key={type.remark} name={'radio-button-type'} value={type.remark}
                                  control={<Radio checked={selectedType === type.remark}/>}
                                  label={type.remark}/>))}
        </RadioGroup>
    }, [limitTypes, selectedType]);

    const renderLimit = useMemo(() => {
        return <RadioGroup onChange={handleLimitChange}>
            {limitTypes.types.length > 0 && limitTypes.types[0].items.map((item, idx) => (
                <FormControlLabel key={item.remark} name={'radio-button-limit'} value={item.remark}
                                  control={<Radio checked={selectedLimit === item.remark}/>}
                                  label={item.remark}/>))}
        </RadioGroup>
    }, [limitTypes, selectedLimit]);

    return <Modal
        handleBtnOk={handleBtnCreateLimit}
        isOpen={isShow}
        handleBtnCancel={handleClose}
    >
        <>
            <Typography style={{marginBottom: ".5rem", fontWeight: "800", textAlign: 'center'}}>{title}</Typography>
            <Grid display={'flex'} alignItems={'start'}>
                <Grid item sm={4} xs={12} sx={{borderRight: '1px solid #ccc', minWidth: '330px', minHeight: "350px"}}>
                    <Grid sx={{display: 'flex'}}>

                        <FormControlLabel control={<Checkbox
                            id={'common'}
                            icon={<IndeterminateCheckBoxIcon/>} checkedIcon={<LibraryAddCheckIcon/>}
                            onClick={handleSelectAll}/>}
                                          label={fnLocalizeFilter(locale, '_lang.module.cards.limits.titlePurses')}
                        />
                    </Grid>
                    <Grid item sx={{display: 'flex', flexDirection: 'column', marginTop: '1rem'}}>
                        {renderPursesCommon}
                    </Grid>
                </Grid>
                <Grid item sm={4} xs={12}
                      sx={{borderRight: '1px solid #ccc', minWidth: '250px', minHeight: "350px", paddingLeft: '.7rem'}}>
                    <Typography align={'center'}>Тип</Typography>
                    {renderType}
                </Grid>
                <Grid item sm={4} xs={12} sx={{
                    minWidth: '250px',
                    height: "350px",
                    paddingLeft: '.7rem',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                }}>
                    <Box>
                        <Typography align={'center'}>Ліміт</Typography>
                        {renderLimit}
                    </Box>
                    <InputFilled
                        type={'number'}
                        label={fnLocalizeFilter(locale, '_lang.module.cards.limits.newLimit.titleLimitAmount')}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLimitAmount(+e.target.value)}
                        value={limitAmount}
                    />
                </Grid>
            </Grid>
        </>
    </Modal>
}
